// src/automation/AutomationRules.js

import { registerAutomation } from "./AutomationRegistry";
import { AutomationEvents } from "./AutomationEvents";

registerAutomation(
  AutomationEvents.WORKER_APPROVED,
  async (worker) => {
    console.log("✅ AUTOMATION TEST PASSED", {
      event: AutomationEvents.WORKER_APPROVED,
      uid: worker.uid,
      email: worker.email,
      facilityId: worker.facilityId,
      tenantId: worker.tenantId,
      approvedBy: worker.approvedBy,
    });
  }
);